<div class="forced-checkin-map">
    <div class="map-container">
        <agm-map [latitude]="lat"
                 [longitude]="lng"
                 [zoom]="zoom"
                 [disableDefaultUI]="true"
                 [fitBounds]="true"
                 [maxZoom]="selectedPlantGlid ? 16 : 8"
                 [styles]="mapStyles"
                 (centerChange)="centerChanged($event)"
                 (zoomChange)="zoomChanged($event)">
            <agm-zoom-control></agm-zoom-control>

            <ng-container class="global-mode" *ngIf="!selectedPlantGlid">
                <ng-container *ngFor="let plant of forcedCheckinResults; let i = index">
                    <agm-marker [latitude]="plant.latitude"
                                [longitude]="plant.longitude"
                                [agmFitBounds]="true"
                                [label]="''+plant.nbForcedCheckin"
                                [iconUrl]="classicMarkerIcon"
                                [zIndex]="MAX_Z_INDEX - i"
                                (markerClick)="selectPlant(plant.glid)">
                        <agm-info-window [isOpen]="true" [style]="">
                            {{plant.name}}
                        </agm-info-window>
                    </agm-marker>
                </ng-container>
            </ng-container>

            <ng-container class="detail-mode" *ngIf="selectedPlantGlid">
                <agm-marker [zIndex]="10"
                            [latitude]="selectedPlantLatitude"
                            [longitude]="selectedPlantLongitude"
                            [iconUrl]="plantMarkerIcon"
                            [agmFitBounds]="true">
                </agm-marker>
                <agm-circle [zIndex]="0"
                            [latitude]="selectedPlantLatitude"
                            [longitude]="selectedPlantLongitude"
                            [radius]="selectedPlantRadius"
                            [fillColor]="'#1070A9'"
                            [fillOpacity]=".1"
                            [strokeColor]="'#1070A9'"
                            [strokeWeight]="2">
                </agm-circle>
                <agm-marker-cluster [gridSize]="30"
                                    [styles]="clusterStyle"
                                    [minimumClusterSize]="2"
                                    [maxZoom]="14"
                                    [zoomOnClick]="true"
                                    [averageCenter]="true">
                    <agm-marker-spider [keepSpiderfied]="true"
                                       [nearbyDistance]="10"
                                       [circleSpiralSwitchover]="6"
                                       [circleStartAngle]="45"
                                       [circleFootSeparation]="75"
                                       [spiralLengthStart]="75"
                                       [spiralLengthFactor]="3"
                                       [spiralFootSeparation]="50">
                        <ng-container *ngFor="let forcedCheckin of plantForcedCheckins">
                            <agm-marker [zIndex]="1"
                                        [latitude]="forcedCheckin.actualLatitude"
                                        [longitude]="forcedCheckin.actualLongitude"
                                        [iconUrl]="checkinMarkerIcon"
                                        [agmFitBounds]="true">
                            </agm-marker>
                        </ng-container>
                    </agm-marker-spider>
                </agm-marker-cluster>
            </ng-container>
        </agm-map>

        <div class="top-left-settings">
            <div class="map-setting bucket-switcher" *ngIf="!showBucket" (click)="showBucketChange.emit(true)">
                <i class="fas fa-filter fa-2x"></i>
                <i class="fas fa-chevron-right fa-x"></i>
            </div>
        </div>
    </div>
</div>
